import { UpOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useEnabledItems, useMenuAddons } from "../../../../hooks/useMenu";
import {
  calculateOrderTotal,
  calculateOrderPricing,
} from "./orderSummaryUtils";

interface OrderItem {
  itemId: number;
  quantity: number;
  modifiers: number[];
  addons: Record<number, Record<number, number>>; // addonId -> { itemId -> количество }
  comment?: string;
}

interface MobileOrderBarProps {
  orderItems: OrderItem[];
  onClick: () => void;
  /** Знаков процент по сметката (клиент с отстъпка/надбавка) — сумата в
   *  лентата съвпада с „Общо" в sheet-а; 0 = без корекция. */
  billDiscountPercent?: number;
}

/**
 * Мобилна кехлибарена лента „Преглед на поръчката" — стои под OrderFooter в
 * долния фиксиран стек и отваря bottom sheet-а с текущата поръчка. Винаги е
 * видима (при празна кошница е disabled), за да не скача layout-ът.
 */
export const MobileOrderBar = ({
  orderItems,
  onClick,
  billDiscountPercent = 0,
}: MobileOrderBarProps) => {
  const { t } = useTranslation();
  const allItems = useEnabledItems();
  const allAddons = useMenuAddons();

  const total =
    billDiscountPercent !== 0
      ? calculateOrderPricing(orderItems, allItems, allAddons, billDiscountPercent)
          .finalTotal
      : calculateOrderTotal(orderItems, allItems, allAddons);
  const isEmpty = orderItems.length === 0;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isEmpty}
      // pb включва ПОЛОВИН safe-area отстъп на iPhone — фонът остава плътен до
      // ръба на екрана, а съдържанието се вдига умерено над home indicator-а
      className={`w-full bg-pos-accent px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px)*0.5)] border-t border-pos-line2 flex items-center gap-2.5 ${
        // При празна кошница избледняват САМО елементите вътре — лентата
        // остава плътна и скролнатото съдържание НЕ прозира под нея
        isEmpty
          ? "cursor-not-allowed [&>*]:opacity-60"
          : "cursor-pointer hover:bg-pos-accent-ink"
      } transition-colors`}
    >
      {/* Бадж с броя редове в поръчката */}
      <span className="min-w-[26px] h-[26px] rounded-full bg-white/25 grid place-items-center font-pos-mono text-[13px] font-bold text-white px-1">
        {orderItems.length}
      </span>
      <span className="text-sm font-semibold text-white">
        {t("ordering.orderPreview")}
      </span>
      <span className="ml-auto font-pos-mono text-[17px] font-bold text-white">
        {total.toFixed(2)} EUR
      </span>
      <UpOutlined className="text-white text-[13px]" />
    </button>
  );
};
